{
  "more_actions": {
    "removed_history": "Removed History",
    "list_settings": "List Settings",
    "manage_columns": "Manage Columns",
    "reminder": "Reminder",
    "add_comment": "Add Comment"
  },
  "lists": {
    "name_required": "Please enter a list name",
    "create_list": "Create List",
    "name": "Name",
    "enable_duplicate_contacts": "Enable duplicate contacts",
    "rename": "Rename List",
    "new_contact_list": "New Contact List",
    "more_actions": {
      "request_contacts": "Request Contacts",
      "clean_list": "Clean List",
      "connected_to": "Connected to",
      "sync_with": "Sync with"
    }
  },
  "company_list": {
    "shared_company_list": "shared company list",
    "personal_company_list": "personal company list",
    "project_company_list": "project company list",
    "list_memberships": "List memberships",
    "import_companies": "Import companies",
    "add_company": "Add Company",
    "add_to_list": "Add to List",
    "edit_company_type": "Edit Company Type",
    "bulk_edit": "Bulk Edit",
    "remove": "Remove",
    "list": "List",
    "company": "Company",
    "add_company_to_list": "Add Company to List",
    "bulk_edit_custom_fields": "Bulk Edit Custom Fields",
    "edit_custom_fields": "Edit Custom Fields",
    "please_select_company": "Please select a company to add to this list",
    "please_choose_list": "Please choose a list",
    "which_company_placeholder": "Which company do you want to add to this list",
    "action_cannot_be_undone": "This action cannot be undone",
    "delete_tab_confirmation": "Are you sure you want to delete this tab?",
    "company_removed_from_list": "The company will be removed from this list.",
    "remove_company_confirmation": "Are you sure you want to remove the company from this list?",
    "remove_company_aria_label": "remove company from this list",
    "loading_companies": "loading companies",
    "more_companies_contact_support": "There are more companies than shown. Please contact NEXL support."
  },
  "my_lists": {
    "page": {
      "create_list": "Create List",
      "search_placeholder": "Search list name",
      "lists_header": "Lists"
    },
    "navigation": {
      "other_lists": "Other Lists"
    },
    "empty_states": {
      "no_shared_list": "No shared list",
      "your_list_is_empty": "Your List is Empty",
      "no_lists_found": "No Lists Found",
      "no_search_results": "We couldn't find any list matching your search. Try using different keywords or create a new list"
    },
    "actions": {
      "add_to_list": "Add to List",
      "list_actions": "List actions",
      "rename_list": "Rename List",
      "share_list": "Share List",
      "add_company": "Add Company",
      "add_contact": "Add Contact",
      "add_generic_item": "Add Item",
      "add_activity": "Add Activity",
      "add_column": "Add Column"
    },
    "forms": {
      "list_name": "List Name",
      "list_name_required": "Please enter a list name",
      "invite": "Invite",
      "invitee_required": "Please choose at least one invitee",
      "enable_duplicate_contacts": "Enable duplicate contacts",
      "duplicate_contacts_tooltip": "Enabling duplicate contacts allows for multiple entries in forms. However, please note that importing and exporting data may not function properly."
    },
    "confirmations": {
      "archive_list_title": "Archive List?",
      "archive_list_content": "Are you sure you want to archive this list? It will be removed from the listing.",
      "remove_user_title": "Are you sure you want to remove this user?",
      "remove_user_content": "Click confirm to remove"
    },
    "share": {
      "invite_tab": "Invite",
      "access_tab": "Access",
      "owner": "Owner",
      "success_message": "Your list has been successfully shared. We will notify the recipients.",
      "loading_users": "Loading users"
    },
    "scopes": {
      "all": {
        "name": "Search Lists",
        "description": "Search for a list you have access to or select from your recently viewed lists."
      },
      "created": {
        "name": "Created by Me",
        "description": "Here are your recently created items. Use search to find others and stay organized tracking your work."
      },
      "shared": {
        "name": "Shared with Me",
        "description": "Search to find a list or select from one of your recent lists shared with you."
      },
      "workspace": {
        "name": "Workspace Lists",
        "description": ""
      },
      "app": {
        "name": "Apps Lists",
        "description": ""
      },
      "marketing": {
        "name": "Marketing Lists",
        "description": ""
      }
    },
    "types": {
      "contact_list": "Create a List of Contacts for your project",
      "company_list": "Create a List of Companies for your project",
      "generic_list": "Create custom list to support your project"
    },
    "empty_descriptions": {
      "shared": "It looks like no one has shared any lists with you yet. When someone shares a list, it will appear here.",
      "marketing": "Start creating your list on Marketing to see them here.",
      "app": "Start creating your list on Apps to see them here.",
      "workspace": "Start creating your list on Workspace to see them here.",
      "default": "Start creating your list to see them here."
    }
  },
  "company_list_grid": {
    "add_company": "Add Company",
    "add_to_list": "Add to List",
    "edit_company_type": "Edit Company Type",
    "bulk_edit": "Bulk Edit",
    "remove": "Remove",
    "import_companies": "Import companies"
  },
  "removed_history": {
    "title": "Removed History",
    "empty_state": {
      "title": "No Removed Contacts",
      "description": "No contacts have been removed from this list yet. Once contacts are removed, they will appear here."
    },
    "table": {
      "selected_count": "{{count}} selected",
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "removed_date": "Removed Date",
        "removed_by": "Removed By"
      }
    },
    "actions": {
      "add_to_list": "Add to list",
      "go_back_tooltip": "go back to {{listName}}"
    }
  },
  "e_marketing_integration": {
    "settings": {
      "title": "eMarketing Settings",
      "sync_to_tools": "Sync to eMarketing Tools",
      "sync_to_tools_caption": "Each time you sync to an eMarketing tools, a new list will be created to their app. You can choose which fields to map, ensuring the right data is included."
    },
    "sync": {
      "title": "Sync Contacts",
      "save_and_sync": "Save and Sync",
      "connector_name": "Connector Name",
      "e_marketing_list_name": "eMarketing List Name",
      "e_marketing_list_name_caption": "If a list with the same name exists in the eMarketing tool, it will be overwritten.",
      "type_connector_name": "Type connector name",
      "select_connector": "Select connector",
      "syncing_tooltip": "Syncing contacts with the eMarketing tool is in progress.",
      "syncing_status": "Syncing..."
    },
    "status": {
      "out_of_sync_title": "List out of sync.",
      "sync_now": "Sync now",
      "sync_now_description": "to update your data.",
      "sync_complete_title": "Sync Complete:",
      "sync_complete_description": "Your contact list has been synced to",
      "sync_failed_title": "Sync Failed:",
      "sync_failed_description": "This may be due to connection issues or incorrect settings. Open",
      "e_marketing_setup": "eMarketing setup",
      "retry_description": "to retry again."
    },
    "disconnect": {
      "title": "Delete Connection?",
      "description": "Are you sure you want to delete this connection? This action will remove the integration, and any ongoing syncs will be stopped. This cannot be undone.",
      "aria_label": "Delete connection",
      "button_title": "Delete connection"
    },
    "field_mapping": {
      "title": "Fields to Map",
      "nexl_fields": "Nexl Fields",
      "concep_fields": "Concep Fields",
      "add_map_field": "Add Map Field",
      "select_nexl_field": "Select Nexl Field",
      "select_remote_field": "Select Remote Field",
      "remove_field_mapping": "Remove field mapping {{index}}"
    }
  },
  "list_cleaner": {
    "status_result": "Status Result",
    "last_verified": "Last verified",
    "verify_list": {
      "button": "Verify List",
      "verifying": "Verifying List",
      "confirmation_title": "Verify List",
      "confirmation_content": "Validate email addresses for accuracy before sending campaigns."
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "location": "Location",
        "last_interaction": "Last Interaction",
        "consent_status": "Consent Status",
        "reason": "Reason",
        "result": "Result",
        "status": "Status",
        "action": "Action"
      },
      "selected_count": "{{count}} selected"
    },
    "actions": {
      "mark_as_low_risk": "Mark as Low Risk",
      "remove_from_list": "Remove from List",
      "list_cleaner_actions": "list cleaner actions"
    },
    "contact_status": {
      "bounced": "Remove bounced",
      "consent_not_given": "Remove from List",
      "total": "Remove from List",
      "unengaged": "Remove unengaged",
      "user_unsubscribed": "Remove unsubscribed"
    },
    "risk": {
      "high_risk": "High Risk",
      "medium_risk": "Medium Risk",
      "low_risk": "Low Risk",
      "unknown_risk": "Unknown Risk",
      "risk_with_level": "{{level}} RISK",
      "tooltips": {
        "high": "Sending to this highly risky address will harm your reputation.",
        "medium": "This is our neutral risk level. Emails not classified as low or high risk default to medium risk.",
        "low": "The email address is likely valid, and sending to it poses a low risk to your reputation."
      }
    },
    "confirmations": {
      "mark_low_risk_title": "Mark as Low Risk?",
      "mark_low_risk_content": "Once marked as low risk, this contact's status cannot be changed until the system re-evaluates in 3 months. Confirm this action?",
      "remove_from_list_title": "Remove from list?",
      "remove_from_list_single": "This contact will be removed from your list.",
      "remove_from_list_multiple": "These contacts will be removed from your list.",
      "remove_all_contacts_title": "Remove all {{type}} contacts from list?",
      "remove_all_contacts_content": "These contacts will be removed from your list."
    },
    "success": {
      "contacts_cleaned_title": "{{type}} Contacts Cleaned!",
      "contacts_cleaned_description": "All {{type}} contacts have been removed. Your list is now more effective and deliverable!"
    },
    "remove_cleaned": {
      "ok": "Ok"
    }
  },
  "contact_list_grid": {
    "filters": {
      "all_contacts": "All",
      "my_contacts": "My Contacts",
      "all_contacts_aria": "Show All Contacts",
      "my_contacts_aria": "Show My Contacts"
    },
    "actions": {
      "add_contact": "Add Contact",
      "import_contacts": "Import contacts",
      "export": "Export",
      "refresh": "Refresh",
      "share": "Share",
      "sync_contacts": "Sync Contacts",
      "syncing": "Syncing",
      "add_tags": "Add Tags",
      "bulk_edit": "Bulk Edit",
      "log_new_activity": "Log New Activity"
    },
    "sync": {
      "failed": "Sync Failed",
      "try_again": "Try Again",
      "out_of_sync": "List out of sync. Sync now to update your data.",
      "complete": "Sync Complete: Your contact list has been synced to {{campaignManagerName}}!",
      "in_progress": "Syncing list, this might take a few minutes..."
    },
    "status": {
      "loading_contacts_aria": "loading contacts",
      "error_prefix": "Error: {{message}}",
      "over_limit": "This list is over the limit, showing only {{count}}.",
      "outdated_list": "The list you are viewing is outdated, click refresh to view the latest changes."
    },
    "tooltips": {
      "duplicate_contacts": "Enabling duplicate contacts allows for multiple entries in forms. However, please note that importing and exporting data may not function properly."
    }
  },
  "expiry": {
    "description": "Set condition to automatically close form submissions.",
    "enable_label": "Enable Expiry Date",
    "date_label": "Expiry Date",
    "date_placeholder": "When will the form expire?",
    "page_header_label": "Expiry Page Header",
    "page_header_placeholder": "Please enter expiry page header",
    "page_description_label": "Expiry Page Description",
    "default_header": "Form Has Expired",
    "default_description": "This form has expired and can no longer be accessed. Please contact the form owner for further assistance.",
    "validation": {
      "date_required": "Please select an expiry date",
      "date_past": "Date time can't be in the past",
      "header_required": "Please enter expiry page header"
    }
  }
}
